
import JobFloatingMediaV3 from "@/components/job/jobpage/JobFloatingMediaV3"
import JobSlideShowV3 from "@/components/job/jobpage/JobSlideShowV3"
import JobGalleryV3 from "@/components/job/jobpage/JobGalleryV3"
import JobContainer from "@/components/job/jobpage/JobContainer"
import themes from "@/mixins/themes"
import intersection from "@/directives/intersection"

export default {
    name: "Section2",
    components: {
        JobFloatingMediaV3,
        JobSlideShowV3,
        JobGalleryV3,
        JobContainer,
    },
    directives: { intersection },
    mixins: [themes],
    props: {
        /** Array of images and videos */
        mediaList: {
            type: Array,
            default: () => [],
        },
    },
    inject: ["editorMode"],
    computed: {
        spacingClasses() {
            return { "eb-pl-10 eb-pl-md-14": this.hasMedia }
        },
        hasMedia() {
            return this.mediaList.length > 0
        },
        galleryMedia() {
            if (this.mediaList.length < 2) return []
            if (this.mediaList.length % 2 === 1) return this.mediaList.slice(1)
            return this.mediaList.slice(2)
        },
        secondaryMedia() {
            return this.mediaList[1]
        },
        mainMedia() {
            return this.mediaList[0]
        },
    },
    methods: {
        onShowMore(medium) {
            this.$fullscreenMedia.open(this.mediaList, { initialId: medium.id })
        },
    },
}
